import i18n from "i18next";
import { useRecoilState } from "recoil";
import { userPersonalInfoState, UserPersonalInfo } from "../../../store/user";
import { UPDATE_PERSONAL_INFO, UPDATE_PERSONAL_PRODUCTS_INFO } from "../queries";
import { useDataMutation } from "../../../hooks/useDataModule";
import { useModelsMutation } from "../../../hooks/useModelsModule";

type simulatorUserUnits = { newCurrency?: string; dosageUnit?: string };
type UsePersonalInfoHook = [
	personalInfo: UserPersonalInfo,
	save: (personalInfo: UserPersonalInfo, units?: simulatorUserUnits, simulatorWasteReportingEnabled?: boolean) => void,

	loading: boolean
];

const usePersonalInfo = (): UsePersonalInfoHook => {
	const [personalInfo, setPersonalInfo] = useRecoilState(userPersonalInfoState);
	const [updatePersonInfo, { loading }] = useDataMutation(UPDATE_PERSONAL_INFO, {
		onCompleted: ({ UpdateCurrentUserPersonalInfo }) => {
			i18n.changeLanguage(UpdateCurrentUserPersonalInfo.preferredLanguage);
			setPersonalInfo({ ...personalInfo, ...UpdateCurrentUserPersonalInfo });
		},
		onError: console.error,
	});

	const [updateLibraryUserInfo, { loading: loadingLibrary }] = useModelsMutation(UPDATE_PERSONAL_PRODUCTS_INFO, {
		onCompleted: ({ UpdateCurrentUserPersonalInfo }) => {
			i18n.changeLanguage(UpdateCurrentUserPersonalInfo.preferredLanguage);
			setPersonalInfo({
				...personalInfo,
				...UpdateCurrentUserPersonalInfo,
			});
		},

		onError: console.error,
	});

	const save = (personalInfo: UserPersonalInfo, units?: simulatorUserUnits, simulatorWasteReportingEnabled?: boolean) => {
		const { firstName, lastName, position, department, preferredLanguage } = personalInfo;
		const personalInfoDTO = { firstName, lastName, position, department, preferredLanguage };
		updatePersonInfo({
			variables: {
				personalInfo: {
					...personalInfoDTO,
				},
			},
		});
		updateLibraryUserInfo({
			variables: {
				personalInfo: {
					...personalInfoDTO,
					currency: units?.newCurrency,
					dosageMeasureUnit: units?.dosageUnit,
					simulatorWasteReportingEnabled: simulatorWasteReportingEnabled ?? personalInfo.simulatorWasteReportingEnabled,
				},
			},
		});
	};

	const loadingSave = loading || loadingLibrary;

	return [personalInfo, save, loadingSave];
};

export default usePersonalInfo;
